import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Recent.css';

const Recent = () => {
  const [recentMovies, setRecentMovies] = useState([]);

  // Fetch recent movies from the API
  useEffect(() => {
    const fetchRecentMovies = async () => {
      const apiKey = process.env.REACT_APP_TMDB_API_KEY;
      try {
        const response = await fetch(
          `https://api.themoviedb.org/3/movie/now_playing?api_key=${apiKey}&language=en-US&page=1`
        );
        const data = await response.json();
        // Ensure that we get exactly 20 recent movies
        if (data.results.length >= 20) {
          setRecentMovies(data.results.slice(0, 20));
        } else {
          setRecentMovies(data.results);
        }
      } catch (error) {
        console.error('Error fetching recent movies:', error);
      }
    };

    fetchRecentMovies();
  }, []);

  return (
    <div className="recent-movies-container">
      <h2 className="recent-movies-heading">Recently Updated Movies</h2>
      <div className="movie-grid">
        {recentMovies.map((movie) => (
          <div key={movie.id} className="movie-item movie-title">
            <Link to={`/movies/${movie.id}`} className="movie-link">
              <img
                src={`https://image.tmdb.org/t/p/w300${movie.poster_path}`}
                alt={movie.title}
                className="movie-poster"
              />
              <div className="movie-title movie-title">{movie.title}</div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recent;
